import type { SlashCommand } from '../../../../../api/agents-client/agent-client.type';

enum CommandScope {
  Global = 'global',
  Organization = 'organization',
  User = 'user',
}

interface GroupedCommands {
  scope: CommandScope;
  label: string;
  commands: SlashCommand[];
}

export { CommandScope };
export type { GroupedCommands };
